module.exports = __webpack_public_path__ + "img/huawei-4.ca55656c.png";